module.exports = __webpack_public_path__ + "img/pos5-bg.128791a3.jpg";